import { render, staticRenderFns } from "./SignupPurpose.vue?vue&type=template&id=a70b5204&scoped=true&"
import script from "./SignupPurpose.vue?vue&type=script&lang=js&"
export * from "./SignupPurpose.vue?vue&type=script&lang=js&"
import style0 from "./SignupPurpose.vue?vue&type=style&index=0&id=a70b5204&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70b5204",
  null
  
)

export default component.exports